exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tW3D2pyaeTSb-b3FIQKBO .stat-box{background-color:dycolor-internal(!stats-background,@theme-light-grey)}.tW3D2pyaeTSb-b3FIQKBO .box-details .close-details,.tW3D2pyaeTSb-b3FIQKBO .box-details .view-details{color:dycolor-internal(!cta-background,@secondary)}\n", ""]);

// exports
exports.locals = {
	"root": "tW3D2pyaeTSb-b3FIQKBO"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules=true!./~/gotu-vue-dycolor/dist/lib/dycolor-loader.js?colors!./~/sass-loader/lib/loader.js?outputStyle=compressed!./src/components/campaign-statistics/stat-box/StatBox.scss
// module id = 885
// module chunks = 1